export default {"src":"/_next/static/media/phone2.b615ecd7.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};